<div class="layout-container">
  <div class="content-wrapper">
    <div class="main-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>

<app-notification [notification]="notification"></app-notification>

<!-- <sh-modal sticky [visible]="dataService.openSavedChangesModal" label='{{ "page-layout.label.save-draft-button" | translate }}'
  modal-height='180px' modal-width='320px' style="z-index: 103;">
  {{ "page-layout.label.save-changes-confirmation" | translate }}
  <div class="modal-footer-buttons">
    <sh-button slot='footer' color='secondary' label='Cancel' (click)="moveHome()"></sh-button>
    <sh-button slot='footer' label='Save' (click)="onSaveChanges()"></sh-button>
  </div>
</sh-modal> -->